import { useRef } from 'react';

import { OpportunityStatus } from '@ndvr/customer-api';

import { useGlobalAccount } from '@/views/household/household-queries';
import { useSubmitOpportunityForm } from '@/views/opportunities/useSubmitOpportunityForm';
import { OpportunityForm, OpportunityFormRef } from '@/views/opportunities/widgets/OpportunityForm';

import { useDockState } from '../dock-state';
import { CreateOpportunityDockItem as CreateOpportunityDockItemType } from '../dock-state-types';

export const CreateOpportunityDockItem = (props: { item: CreateOpportunityDockItemType }) => {
    const { data: prospect } = useGlobalAccount(props.item.data.prospectGUID);
    const { setActiveId, updateDockItem, removeDockItem } = useDockState();
    const formRef = useRef<OpportunityFormRef>(null);
    const submitOpportunityForm = useSubmitOpportunityForm();

    if (props.item.data.prospectGUID && !prospect) return null;

    return (
        <div
            onBlur={() => {
                const formValues = formRef.current?.formMethods.getValues();
                if (formValues) {
                    updateDockItem({
                        ...props.item,
                        data: {
                            ...props.item.data,
                            name: formValues?.name || '',
                            description: formValues?.description || '',
                            value: formValues?.value || '',
                            prospectOption: formValues?.prospectOption,
                            statusOption: formValues?.statusOption || {
                                value: OpportunityStatus.IDENTIFIED,
                                label: 'Identified',
                            },
                        },
                    });
                }
            }}
        >
            <OpportunityForm
                key={props.item.id}
                ref={formRef}
                showProspectInput={props.item.data.showProspectInput}
                prospectGUID={props.item.data.prospectGUID}
                defaultValues={{
                    name: props.item.data.name,
                    description: props.item.data.description,
                    value: props.item.data.value,
                    prospectOption: props.item.data.prospectOption,
                    statusOption: props.item.data.statusOption,
                }}
                onSubmit={async (data) => {
                    if (await submitOpportunityForm.submit(data, props.item.data.link)) removeDockItem(props.item.id);
                }}
                onCancel={() => setActiveId(null)}
            />
        </div>
    );
};
